// extracted by mini-css-extract-plugin
export default {"titleCol":"styles_titleCol__upyhv","title":"styles_title__SC2Pn","wrapper":"styles_wrapper__tHVKe"};